
import React, { useEffect } from 'react';
import { Form, Button, Row, Col, Select } from 'antd';
import { FaBed, FaMinus, FaPlus, FaRegPlusSquare } from 'react-icons/fa';

const { Option } = Select;

const RoomSelectionPopoverContent = ({
    rooms,
    addRoom,
    removeRoom,
    addAdults,
    removeAdults,
    addChildren,
    removeChildren,
    onSelectChildAge,
    applyChanges,
    form
}) => {

    useEffect(() => {
        if (rooms?.length) {
            const fieldValues = {};
            rooms?.forEach((room, roomIndex) => {
                room.childAge.forEach((age, childIndex) => {
                    fieldValues[`childAge-${roomIndex}-${childIndex}`] = age || undefined;
                });
            });
            form.setFieldsValue(fieldValues);
        }
    }, [rooms, form]);

    return (

        <Form
            form={form}
            className='popup-form hotel-room-select'
            style={{ width: '100%', minWidth: '320px' }}
            onFinish={applyChanges}
        >
            <div className='popup-inner'>
               
                {rooms?.map((room, index) => (
                    <div key={index}>
                        <div className='d-flex align-items-center justify-content-between mt-2 mb-3'>
                            <h3><FaBed /> Room {index + 1}</h3>
                            {rooms.length > 1 && (
                                <button
                                    onClick={(e) => removeRoom(index, e)}
                                    className='btn px-2 border text-primary py-1'
                                    aria-label="Remove"
                                >
                                    Remove
                                </button>
                            )}
                        </div>

                        <div className='d-md-flex align-items-center justify-content-between border-bottom'>
                            <div className='select-adult mb-2 pe-md-3 me-md-3'>
                                <h6>Adults</h6>
                                <span className='selection'>
                                    <Button className='me-3' onClick={() => removeAdults(index)} aria-label="remove adult"><FaMinus /></Button>
                                    <span className='me-3'>{rooms[index].numberOfAdults}</span>
                                    <Button onClick={() => addAdults(index)} disabled={rooms[index].numberOfAdults >= 3} aria-label="add adult"><FaPlus /></Button>
                                </span>
                            </div>

                            <div className='select-child mb-2'>
                                <h6>Children</h6>
                                <span className='selection'>
                                    <Button className='me-3' onClick={() => removeChildren(index)} aria-label="remove child"><FaMinus /></Button>
                                    <span className='me-3'>{rooms[index].numberOfChild}</span>
                                    <Button onClick={() => addChildren(index)} disabled={rooms[index].numberOfChild >= 3} aria-label="add child">
                                        <FaPlus />
                                    </Button>
                                </span>
                            </div>
                        </div>

                        <Row gutter={16}>
                            {rooms[index].childAge.map((ageValue, childIndex) => (
                                <Col xs={24} md={8} key={childIndex} className="w-100">
                                    <div className="select-amount">
                                        <Form.Item
                                            name={`childAge-${index}-${childIndex}`}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please select age',
                                                },
                                            ]}
                                        >
                                            <Select
                                                value={rooms[index].childAge[childIndex] || undefined} // ✅ show JSON value
                                                onChange={(value) => onSelectChildAge(value, index, childIndex)} // ✅ update on change
                                                placeholder="Select age"
                                                style={{ width: '100%' }}
                                                className="my-2"
                                            >
                                                {[...Array(12)].map((_, i) => (
                                                    <Select.Option key={i + 1} value={i + 1}>
                                                        {i + 1} years old
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </div>
                ))}

                {rooms.length === 5 && <p>Maximum 5 rooms can be added</p>}
                <div onClick={addRoom} disabled={rooms.length >= 5} style={{ cursor: "pointer" }} className='d-flex align-items-center border-0 bg-white text-right my-2'>
                    <FaRegPlusSquare className='me-1' style={{ fontSize: '20px' }} /> Add Room
                </div>

                <Button htmlType='submit' className='w-100 btn btn-primary' aria-label="Done">
                    Done
                </Button>
            </div>
        </Form>
    );
};

export default RoomSelectionPopoverContent;